import { useAppScopeStore } from '@frontend/scope';
import { useAppFlagStore } from '@frontend/shared';

export const useGetFusionEnabled = (locationIds?: string[]) => {
  const { selectedLocationIds } = useAppScopeStore();
  const { getFeatureFlagValue } = useAppFlagStore();
  const fusionEnabled = getFeatureFlagValue({
    flagName: 'nwx:inbox-fusion',
    locationIds: locationIds || selectedLocationIds,
    strategy: 'ANY',
  });
  return fusionEnabled;
};
